// extracted by mini-css-extract-plugin
export default {"loading-container":"YbUFQ","loadingContainer":"YbUFQ"};